import React, { useEffect, useState } from 'react';
import { useMediaQuery } from "react-responsive";

import SlButton from '@shoelace-style/shoelace/dist/react/button';
import { MdAutoFixHigh } from "react-icons/md";
import { IoShapes } from "react-icons/io5";
import { BsGearWideConnected } from "react-icons/bs";
import { FaListCheck } from "react-icons/fa6";

import FileDropZone from '../../components/FileDropZone/FileDropZone';
import DialogError from '../../components/DialogError/DialogError';
import DividerHeading from '../../components/DividerHeading/DividerHeading';
import FileHistory from '../../components/FileHistory/FileHistory';

import { safeRetrieve } from '../../utils/safeStoring';
import { makeToast } from '../../utils/makeToast';
import { sPullFile } from '../../utils/sPullFile';
import { getIndexAll, dBridgeTableInsert, dBridgeTableDelete } from '../../utils/dbridge_iface';
import { historyConf } from './historyConf';


function MarelliRegistri () {


    // const dummyHistory = [
    //     {
    //         marelli_ledger_id: 1,
    //         file_s3_key: "2024-05-report-001.csv",
    //         entity: "Entity_X",
    //         period: "Settembre 2024",
    //         created_at: "2024-06-11 10:11:21"
    //     },
    //     {
    //         marelli_ledger_id: 2,
    //         file_s3_key: "2024-05-report-002.csv",
    //         entity: "Entity_Y",
    //         period: "2024-Q2",
    //         created_at: "2024-06-11 15:26:42",   // Same day as previous
    //         isNew: true
    //     },
    //     {
    //         marelli_ledger_id: 3,
    //         file_s3_key: "2024-06-report-001.csv",
    //         entity: "Entity_X",
    //         period: "2024-Q2",
    //         created_at: "2024-06-08 09:02:10"
    //     },
    //     {
    //         marelli_ledger_id: 4,
    //         file_s3_key: "2024-04-report-008.csv",
    //         entity: "Entity_Z",
    //         period: "2024-Q1",
    //         created_at: "2024-05-27 14:37:50"
    //     }
    // ];


    const isColumnLayout = useMediaQuery({ maxWidth: 900 });
    
    const [isOpenError, setIsOpenError] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([
        // {"fileName": "This is a long title for a document.docx", 's3Key': '', 'uploaded': false, 'deleting': false}
    ]);
    const [isWaitingResponse, setIsWaitingResponse] = useState(false);

    const [history, setHistory] = useState([]);


    useEffect(() => {
        // retrieve history from the database
        getIndexAll('marelli_ledger')
        .then((res) => {
            console.log('History retrieved successfully', res);
            setHistory(res);
        })
    }, []);


    const handleConvertion = () => {
    
        // check if there are files to send
        if (uploadedFiles.length === 0) {
          return;
        }
    
        // check if all files are uploaded
        if (!uploadedFiles.every(file => file.uploaded)) {
          return;
        }
    
        setIsWaitingResponse(true);

        const apiUrl = process.env.REACT_APP_API_URL || '';
        const apiKey = safeRetrieve('APIKEY_v2');
        fetch(`${apiUrl}/api/ordimastro/v2/clean_ledger`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                api_key: apiKey,
                files_s3_keys: uploadedFiles.map(file => file.s3Key),
                user_history: history,
            }),
        })
        .then((response) => {
            if (!response.ok) {
                return response.json().then((errorData) => {
                    console.error(`Error in clean_ledger response: ${response.status}`, errorData);
                    // makeToast(`C'è stato un errore nel processo di conversione, per favore controlla che il documento caricato sia conforme ai requisiti. Se necessario, contatta l'amministratore di sistema.`, 'warning');
                    setIsOpenError(true);
                    setIsWaitingResponse(false);
                });
            }
            return response.json();  // Proceed to parse JSON if the response is OK
        })
        .then((data) => {
            // add a new entry to the database
            const resultEntry = {
                "file_s3_key": data.body.s3_key,
                "entity": data.body.metadata.entity,
                "period": data.body.metadata.period,
                "year": data.body.metadata.year,
                "month": data.body.metadata.month,
                "last_protocol_number_buy": data.body.metadata.last_protocol_number_buy,
                "last_protocol_number_sell": data.body.metadata.last_protocol_number_sell,
                "document_type": data.body.metadata.document_type
            }
            dBridgeTableInsert('marelli_ledger', resultEntry)
            .then((insertedEntry) => {
                if (Object.keys(insertedEntry).length > 0) {
                    console.log('Entry inserted successfully', resultEntry);
                    // concatenate the new entry on top of the existing history
                    insertedEntry.isNew = true;
                    setHistory([insertedEntry, ...history]);
                    setIsWaitingResponse(false);
                } else {
                    console.log('Entry not inserted', resultEntry);
                    setIsOpenError(true);
                    setIsWaitingResponse(false);
                }
            })
        })
        .catch((error) => {
            console.error('Request failed:', error);
            makeToast('Si è verificato un errore di rete. Per favore riprova più tardi.', 'warning');
            setIsWaitingResponse(false);
        });
    
    }


    const handleHistoryDownload = (entry) => {
        sPullFile(entry.file_s3_key);
    }


    const handleHistoryDelete = (entry) => {
        dBridgeTableDelete('marelli_ledger', 'marelli_ledger_id', entry.marelli_ledger_id)
        .then((success) => {
            if (success) {
                console.log('Entry deleted successfully', entry);
                // remove entry from history
                const newHistory = history.filter(item => item.marelli_ledger_id !== entry.marelli_ledger_id);
                setHistory(newHistory);
            } else {
                console.log('Entry not deleted', entry);
            }
        })
    }
    


    const ExtractButton = () => {
        return (
            <SlButton 
                variant="primary"
                size="large"
                pill
                className="btn-primary"
                style={{ alignSelf: 'center' }}
                loading={isWaitingResponse}
                onClick={handleConvertion}
                disabled={
                    !(uploadedFiles.every(file => file.uploaded)) 
                    || (uploadedFiles.length === 0)
                }
            >
                <MdAutoFixHigh className='icon' />
                <span>Converti in Registro IVA</span>
            </SlButton>
        );
    };



    return (

        <div className="page-F24Datev">
            
            <div className='top-row' style={{ flexDirection: `${isColumnLayout ? 'column' : 'row'}` }} >

                <div className='top-row-left' style={{ flex: 3 }}>

                    <span className='title'>
                        Trasforma i dati SAP per la rendicontazione IVA
                    </span>
                    <span>
                        Carica direttamente i file estratti da SAP e ottieni in automatico un file Excel pronto per la rendicontazione istituzionale IVA. Il tool applica le logiche corrette per ciascun tax code, considerando la società del gruppo di riferimento, e segnala eventuali incongruenze nei dati.
                    </span>
                    <ul style={{ listStyleType: 'none', paddingLeft: '0' }}>
                        <li>
                            <div className='icon'><BsGearWideConnected /></div>
                            <span><strong>Automazione completa</strong> - Il file caricato viene trasformato in un layout Excel ufficiale, senza necessità di interventi manuali.</span>
                        </li>
                        <li>
                            <div className='icon'><FaListCheck /></div>
                            <span><strong>Controlli intelligenti</strong> - Il sistema evidenzia incongruenze e anomalie nei dati.</span>
                        </li>
                        <li>
                            <div className='icon'><IoShapes  /></div>
                            <span><strong>Personalizzazione per società</strong> - Ogni società del gruppo viene gestita in base alle sue logiche contabili e fiscali specifiche.</span>
                        </li>
                    </ul>

                    {!isColumnLayout && (
                        <ExtractButton />
                    )}
                
                </div>

                <div className='top-row-right' style={{ flex: 7 }}>

                    <FileDropZone 
                        uploadedFiles={uploadedFiles}
                        setUploadedFiles={setUploadedFiles}
                        useCaseName="marelli-registri-iva"
                        isWaiting={isWaitingResponse}
                    />
                
                </div>

                {isColumnLayout && (
                    <ExtractButton />
                )}

            </div>

            {history.length > 0 && (
                <>
                <DividerHeading text="Storico elaborazioni" />

                <FileHistory
                    data={history}
                    datetimeField={historyConf.datetimeField}
                    showInfo={historyConf.showInfo}
                    onDownload={handleHistoryDownload}
                    onDelete={handleHistoryDelete}
                />
                </>
            )}

            <DialogError 
                isOpen={isOpenError}
                setIsOpen={setIsOpenError}
            />
        
        </div>

    );
}

export default MarelliRegistri;
